module.exports = __webpack_public_path__ + "static/img/服务保障动态图.b7d8b5b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/服务保障动态图.gif
// module id = uJ0J
// module chunks = 3